export interface Api {
  isMobile: () => boolean;
}

const api: Api = {
  isMobile: () => window.matchMedia('only screen and (max-width: 600px)').matches,
};

export default api;
